// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c393f001/" + chunkId + "." + __webpack_require__.h() + ".vc393f001.js";
};